<template>
  <div class="full-height">
    <crud-layout
      ref="crudLayout"
      :name="name"
      :interface="nmInterface"
      :id="id"
      :page="page"
      :page-detail="pageDetail"
    />
    <q-dialog v-if="flModal" v-model="flModal">
      <q-layout view="Lhh lpR fff" container class="bg-white modal-medium">
        <q-header class="bg-primary">
          <q-toolbar>
            <q-toolbar-title>{{ pageDialog.name }}</q-toolbar-title>
            <q-btn v-close-popup flat round dense size="1.5em" icon="cancel" />
          </q-toolbar>
        </q-header>
        <q-page-container class="card-container-modal">
          <component
            :is="pageDialog.page"
            :name="pageDialog.name"
            :params="pageDialog.params"
            :forms="pageDialog.forms"
            :datatable="pageDialog.datatable"
            :parent="pageDialog.parent"
            inside-modal
            @action-button="handleCustomButton"
            @show-message="showMessage"
          />
        </q-page-container>
      </q-layout>
    </q-dialog>
    <q-dialog v-model="show" maximized>
        <q-layout view="Lhh lpR fff" container class="bg-white modal-medium">
          <q-header class="bg-primary">
            <q-toolbar>
              <q-toolbar-title>
                <translate>{{ label }}</translate>
              </q-toolbar-title>
              <q-btn v-close-popup flat round dense icon="close" @click="() => {show = false}" />
            </q-toolbar>
          </q-header>
          <q-page-container>
            <client-page
              :id="client"
              :name="name"
            />
          </q-page-container>
        </q-layout>
      </q-dialog>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import GeneratorPage from './GeneratorPage'
import { repository } from 'jtech'
import ClientPage from 'src/modules/client/ClientPage.vue'

const { CrudLayout, pageDetail } = JtCrud

@Component({
  name: 'Generator',
  components: { CrudLayout, GeneratorPage, ClientPage },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class Generator extends Vue {
  flModal = false
  pageDialog = null
  show = false

  get nmInterface () {
    return this.interface
  }

  get page () {
    return GeneratorPage
  }

  mounted () {
    this.$refs.crudLayout.onButton('icDetalharCliente', this.detalharCliente)
    this.$refs.crudLayout.onButton('icDetalharDocumentWasteCertified', this.detalharDocument)
    this.$refs.crudLayout.onButton('icDetalharDocumentConsentLetter', this.detalharDocument)
    this.$refs.crudLayout.onButton('btGravar', this.btGravar)
    this.$refs.crudLayout.onButton('icAlterarComposicaoClient', this.handleCustomButton)
  }

  handleCustomButton ({ button, params, page, controller }) {
    switch (button.name) {
      case 'icAlterarComposicaoClient':
        this.showClientForm(params)
        break
      default:
        this.actionButtonDialog(button, params, page)
        break
    }
  }

  showClientForm (params) {
    this.client = params.id
    this.name = params.name
    this.show = true
  }

  async btGravar ({ button, params, page, controller }) {
    await repository.create(button.action, params)
    if (page.limparForm) page.limparForm()
    page.forms[0].dadosForm = { boundResidues: [] }
    this.$refs.inputs.resetValidation()
  }

  async detalharDocument ({ button, params, page, controller }) {
    const forms = await repository.resolve(button.action, params)
    this.pageDialog = {
      page: pageDetail,
      name: forms[0].label,
      params: params,
      forms: forms,
      parent: page
    }
    this.flModal = true
  }

  async detalharCliente ({ button, params, page, controller }) {
    const forms = await repository.resolve(button.action, params)
    this.pageDialog = {
      page: pageDetail,
      name: forms[0].label,
      params: params,
      forms: forms,
      parent: page
    }
    this.flModal = true
  }

  actionButtonDialog (button, params, page) {
    this.flModal = false
    this.$router.push({
      name: 'clientPage',
      params: {
        reload: true,
        link: 'clientPage',
        ...params,
        name: params.name
      },
      force: true,
      reload: true
    })
  }
}
export default Generator
</script>
<style lang="stylus" scoped></style>
